import { generateSingleElimination } from './singleEliminationGenerator';
import { generateRoundRobinFormat } from './roundRobinGenerator';
import { generateGroupKnockout } from './groupKnockoutGenerator';
import { generateCompassDraw } from './compassDrawGenerator';
import { generateRegionalBracket } from './regionalBracketGenerator';
import { generatePagePlayoff } from './pagePlayoffGenerator';
import { generateCrossGroup } from './crossGroupGenerator';
import { generateLadder } from './ladderGenerator';

const GENERATORS = {
  single_elimination: (participants) => generateSingleElimination(participants),
  round_robin: (participants, options) => generateRoundRobinFormat(participants, options),
  group_knockout: (participants, options) => generateGroupKnockout(participants, options),
  compass_draw: (participants) => generateCompassDraw(participants),
  regional_bracket: (participants, options) => generateRegionalBracket(participants, options),
  page_playoff: (participants, options) => generatePagePlayoff(participants, options),
  cross_group: (participants, options) => generateCrossGroup(participants, options),
  ladder: (participants, options) => generateLadder(participants, options),
};

export const generateSchedule = (formatId, participants, options = {}) => {
  const generator = GENERATORS[formatId];
  if (!generator) {
    throw new Error(`No schedule generator registered for format "${formatId}"`);
  }
  return generator(participants, options);
};

export {
  generateSingleElimination,
  generateRoundRobinFormat,
  generateGroupKnockout,
  generateCompassDraw,
  generateRegionalBracket,
  generatePagePlayoff,
  generateCrossGroup,
  generateLadder,
};
